import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';

const isNotAuthorized = (status) => status === httpErrorsTypes.NOT_AUTHORIZED;
const isNetworkError = (status) => !status;

export default {
    isNotAuthorized,
    isNetworkError,
};
